export default () => ({


	init() {
		this.navbar = document.getElementById("navbar");
		const basket = document.querySelector("#cart-quantity .qty-value");
		if (basket) {
			window.addEventListener('cartUpdated', (event) => {
				const totalQty = event.detail.totalQty;
				if (totalQty) {
					basket.textContent = totalQty;
				} else {
					basket.textContent = '';
				}
			});
		}
	},
	submit(id) {
		this.$refs.btn.disabled = true;
		this.$refs.btn.classList.add('opcatity-50');

		const formData = new FormData(this.$refs.form);
		formData.append('CRAFT_CSRF_TOKEN', window.csrfTokenValue);

		fetch('/commerce/cart/update-cart', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: formData
		})
		.then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		})
		.then(data => {
			// trigger a window event to update the cart quantity
			window.dispatchEvent(new CustomEvent('cartUpdated', {
				detail: {
					totalQty: data.cart.totalQty
				}
			}));
			this.$refs.btn.classList.add('hidden');
			this.$refs.check.classList.remove('hidden');
			this.navbar.classList.remove('hide');
		})
		.catch(error => {
			console.error('Error:', error);
			alert('There was an error adding the exercise to your cart. Please try again later.');
		});
		
	}
})